import {mountFacebookTag} from './mountFacebookTag';
import {mountGoogleTag} from './mountGoogleTag';
import {mountLinkedInTag} from './mountLinkedInTag';
import type {AnalyticsTag} from 'Utility/investorFlow/entity';

const mapTags = {
  gtm: mountGoogleTag,
  facebook: mountFacebookTag,
  linkedin: mountLinkedInTag,
};

const mountTag = (tag: AnalyticsTag) => {
  const mount = mapTags[tag.provider];
  if (mount && tag.external_tracking_id) {
    if (tag.provider === 'gtm' && tag.analytics_domain) {
      mount(tag.external_tracking_id, tag.analytics_domain);
    } else {
      mount(tag.external_tracking_id);
    }
  }
};

export const mountTags = (tags: AnalyticsTag[]) => {
  tags.forEach(mountTag);
};
